import gql from "graphql-tag";
import PinnableCommentFields from "../../fragments/PinnableCommentFields";

export default gql`
  mutation UnpinAssetDiscussionComment($commentId: ObjectID!) {
    unpinAssetDiscussionComment(commentId: $commentId) {
      _id
      ...PinnableCommentFields
    }
  }

  ${PinnableCommentFields}
`;
